import gql from 'graphql-tag';

const mutation = gql`
    mutation UserAgreementToNotifyAboutDietCourse($agreement: Boolean!) {
        me {
            agreementToNotifyAboutDietCourse(agreement: $agreement) {
                code
            }
        }
    }
`;

export default mutation;
